import { Grid } from "@mui/material";
import { OLClearIcon } from "components/CustomIcons/OLClearIcon";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { TextInput } from "components/FormControls/TextInput";
import { useMessage } from "hooks/intl";
import { memo } from "react";
import { useStyles } from "../TierSetForm.styles";

interface Props {
  index: number;
  item: { name?: string; description?: string; code?: string };
  remove: (index: number) => void;
  isAnyTranslationAdded: boolean;
}

export const Translation = memo(
  ({ index, item, remove, isAnyTranslationAdded }: Props) => {
    const classes = useStyles();
    const { message } = useMessage();

    return (
      <section
        className={`${classes.translationSection} ${classes.conditionWrapper}`}
      >
        <Grid container spacing={16}>
          <Grid item xs>
            <TextInput
              className={classes.fullWidth}
              data-test-id="name"
              label={
                index === 0 ? (
                  <RequiredFieldLabel
                    text={`${message({
                      id: "tierSetName",
                    })} (${item?.code})`}
                  />
                ) : (
                  `${message({
                    id: "tierSetName",
                  })} (${item?.code})`
                )
              }
              name={`translations[${index}].name`}
            />
          </Grid>
          <Grid item xs>
            <TextInput
              className={classes.fullWidth}
              data-test-id="description"
              label={`${message({
                id: "tierSetDescription",
              })} (${item?.code})`}
              multiline
              name={`translations[${index}].description`}
            />
          </Grid>
          {index > 0 ? (
            <Grid xs="auto" item alignSelf="center">
              <div
                className={`${
                  isAnyTranslationAdded ? classes.clearIconWidth : ""
                }`}
              >
                <OLClearIcon
                  data-test-id="clear"
                  onClick={() => remove(index)}
                />
              </div>
            </Grid>
          ) : (
            <Grid
              xs="auto"
              item
              className={`${isAnyTranslationAdded ? "" : classes.zeroPadding}`}
            >
              <div
                className={`${
                  isAnyTranslationAdded ? classes.clearIconWidth : ""
                }`}
              ></div>
            </Grid>
          )}
        </Grid>
      </section>
    );
  },
);
